import {
  assign, endpoint, options, check, convert,
} from './helpers';

/**
 * According to the given key word,
 * the server brings the elements into the relevant groups.
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const search = (properties) => {
  const props = assign(properties);
  const model = {
    Search: props.data.search || [],
  };

  fetch(endpoint('/search'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default search;
